<template>
    <div class="newscontain" id="jumpnews">
        <img src="@/assets/news/backline.png" class="bgline" />
        <div class="main-title">{{getLan('b6572163-8e52-4077-b47a-1d3e8855b907')}}</div>
        <div class="news">
            <el-timeline style="max-width: 80%">
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2022 Dec 31"
                >
                    {{getLan('5536aad9-ad51-4476-b4d0-19bbfcb6814a')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2021 Aug 30"
                >
                    {{getLan('ef16434e-f467-43f4-80db-80b8cb81f29b')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2020 Dec 09"
                >
                    {{getLan('31fbc032-10fd-4ecb-add5-1fe572fc027d')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2019 Oct 08"
                >
                    {{getLan('10ac58aa-7df9-40f9-8c62-545870c2a6d6')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2019 Sept 17"
                >
                    {{getLan('2a79bf09-c53f-4243-bf04-a99797c91034')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2018 Dec 31"
                >
                    {{getLan('e7329708-c5ea-4ad1-9346-c38c014e98d1')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2018 Apr 02"
                >
                    {{getLan('9e58fa69-1623-4f80-9fb3-14a3a8902e03')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2017 Feb 15"
                >
                    {{getLan('33663fa2-d906-43a2-b229-3d9bd49ef624')}}
                </el-timeline-item>
                <el-timeline-item
                    placement="top" size="large"
                    timestamp="2016 Feb 03"
                >
                    {{getLan('ce0af3ad-d83c-4c35-81f5-7537523be8fa')}}
                </el-timeline-item>
            </el-timeline>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            activity: 0,
        }
    },
    methods: {
        changeSlide(i) {
            this.activity = i
        }
    },
    computed: {

    },
}
</script>

<style scoped>
.newscontain {
    padding-top: 4.97rem;
    padding-left: 20rem;
    padding-bottom: 11.31rem;
    position: relative;
    width: 100rem;
    box-sizing: border-box;
    background: #fff;
}
.main-title {
    color: #333;
    font-size: 2.09rem;
    font-weight: bold;
    line-height: 3.8rem;
}
.news {
    margin-top: 3.25rem;
    position: relative;
}
.news .left {
    display: inline-block;
    width: 16.65rem;
    font-size: 1.36rem;
    height: 20.31rem;
    vertical-align: top;
    padding-right: 2.77rem;
    padding-top: 6.17rem;
    box-sizing: border-box;
}
.news .right {
    display: inline-block;
    width: 45rem;
    height: 25rem;
    box-sizing: border-box;
}
.right img {
    width: 45rem;
    height: 25rem;
}
.swiper-pagination {
    text-align: center;
    width: 45.77rem;
    height: 0.28rem;
}
.swiper-pagination-bullet {
    margin: 4rem;
}
.bgline {
    position: absolute;
    bottom: 2rem;
    left: 0;
    width: 100rem;
}
/* 包裹自定义分页器的div的位置的样式 */
.swiper-pagination-custom {
    bottom: -1.05rem;
    left: 16.65rem;
}
@media (min-width: 1156px) {
    .newscontain {
        padding-left: 20rem;
    }
}
@media (max-width: 1156px) {
    .newscontain {
        padding-left: 10rem;
    }
    .news .right {
        width: 62rem;
        height: 38rem;
    }
    .right img {
        width: 62rem;
        height: 38rem;
    }
}
</style>
<style>
.swiper-pagination-customs {
    background: #c3c3c3; /* 未轮播到的图片分页样式 */
    background-origin: content-box;
    display: inline-block;
    width: 25%;
    height: 0.28rem;
    font-size: 3rem;
    border-right: 0.54rem solid #fff;
    box-sizing: border-box;
}
/*自定义分页器激活时的样式表现*/
.swiper-pagination-customs-active {
    background: #fd9a27;
    font-size: 3rem;
}
.el-timeline-item__content{
    font-size: 16px;
    color: #666666;
}
.el-timeline-item__timestamp{
    font-size: 15px;
}
</style>


// WEBPACK FOOTER //
// src/components/News.vue